{
  "landing": {
    "brand": "Admiralty",
    "hero": {
      "title1": "Lay the guns.",
      "title2": "Read the water.",
      "tagline": "Naval battles in your browser. Free, in minutes.",
      "play": "Play free",
      "signIn": "Sign in",
      "chip": {
        "hulls": "hulls",
        "modes": "modes",
        "ranks": "ranks",
        "minutes": "min battles"
      }
    },
    "nav": {
      "home": "Back to the top",
      "fleet": "Fleet",
      "modes": "Modes",
      "ranks": "Ranks",
      "harbour": "Harbour",
      "notices": "News",
      "faq": "FAQ",
      "sections": "Sections"
    },
    "sound": {
      "mute": "Mute sound",
      "unmute": "Unmute sound"
    },
    "fleet": {
      "title": "The fleet",
      "line": "Three classes, thirteen hulls. Pick one.",
      "class": {
        "destroyer": {
          "name": "Destroyer",
          "alt": "A destroyer driving through a rough sea",
          "blurb": "Fast and light. Torpedoes up close, gone before the reply lands."
        },
        "cruiser": {
          "name": "Cruiser",
          "alt": "A cruiser at speed under a low sky",
          "blurb": "The balance of the three: guns that reach, armour that holds, speed enough to choose the range."
        },
        "battleship": {
          "name": "Battleship",
          "alt": "A battleship firing, her deck wreathed in smoke",
          "blurb": "Slow and heavy. The guns that decide a battle, if she lives long enough to fire them."
        }
      },
      "stat": {
        "hp": "Hull",
        "speed": "Speed",
        "guns": "Guns"
      },
      "knots": "kn",
      "tier": "Tier {n}",
      "pick": "Choose a class"
    },
    "modes": {
      "title": "Five ways to fight",
      "line": "Tap a card to turn it over for its chart.",
      "showChart": "Show the chart",
      "showPainting": "Show the painting",
      "back": {
        "rings": {
          "one": "{count} ring",
          "other": "{count} rings"
        },
        "noRings": "No rings",
        "clock": "{n} min clock"
      }
    },
    "ranks": {
      "title": "Rise through the ranks",
      "line": "Fifteen ranks. Win battles, earn your flag.",
      "counter": "Rank {n} of {total}",
      "xp": "{xp} XP",
      "medals": "Season medals",
      "portrait": "Your captain as a {rank}"
    },
    "harbour": {
      "title": "Your harbour",
      "line": "Between battles: refit, research, shop.",
      "frame": "The harbour, as it looks in the game"
    },
    "notices": {
      "caption": "Admiralty news",
      "close": "Close"
    },
    "faq": {
      "caption": "Before you enlist"
    },
    "final": {
      "tagline": "Your ship is waiting.",
      "play": "Play free"
    },
    "enlist": {
      "terms": "Terms of service",
      "privacy": "Privacy policy",
      "credit": "A Tactus game"
    },
    "footer": {
      "game": "Game",
      "company": "Company",
      "contact": "Contact",
      "follow": "Follow",
      "payment": "Payment methods"
    }
  },
  "slip": {
    "credits": "+{count} credits",
    "seals": "+{count} seals",
    "xp": "+{count} XP",
    "passXp": "+{count} pass XP",
    "desertion": {
      "title": "You abandoned a battle",
      "detail": "Rating -{rating}, fined {credits} credits"
    }
  },
  "common": {
    "harbour": "Harbour",
    "back": "Back",
    "close": "Close",
    "cancel": "Cancel",
    "buy": "Buy",
    "owned": "Owned",
    "equip": "Equip",
    "select": "Select",
    "premium": "Premium",
    "working": "…",
    "signOut": "Sign out",
    "admin": "Admin",
    "credits": "Credits",
    "diamonds": "Seals",
    "topUp": "Top up",
    "nobodyYet": "Nobody yet.",
    "unnamed": "Unnamed"
  },
  "confirm": {
    "cancel": "Cancel",
    "buy": "Buy",
    "xpUnit": "XP",
    "title": "Confirm",
    "signOut": {
      "title": "Sign out",
      "body": "The session ends here. Your progress stays on the account.",
      "going": "Signing out…"
    }
  },
  "stations": {
    "shipyard": {
      "label": "Shipyard",
      "hint": "Hulls, guns, modules"
    },
    "profile": {
      "label": "Record",
      "hint": "Rank, log, orders"
    },
    "shop": {
      "label": "Chandler",
      "hint": "Seals and stores"
    },
    "sea": {
      "label": "Put to Sea",
      "hint": "Sail into battle"
    },
    "research": {
      "label": "Drawing Office",
      "hint": "Research tree"
    },
    "office": {
      "label": "Harbour Office",
      "hint": "Notices, settings"
    },
    "papers": {
      "label": "Papers",
      "hint": "Account, billing, invoices"
    }
  },
  "anchorage": {
    "hullNumber": "D-01",
    "actions": "Harbour",
    "purse": "Purse — the chandler's",
    "ordersStamp": "{count} ready",
    "desk": "Harbour master's desk",
    "research": "Research",
    "shipyard": "Shipyard",
    "training": "Training",
    "stations": "Stations"
  },
  "tarp": {
    "sortie": "Sortie",
    "harbour": "Harbour",
    "drawingOffice": "Drawing office"
  },
  "loading": {
    "tipLabel": "Tip",
    "sea": "Putting to sea…",
    "harbour": "Coming alongside…",
    "papers": "Checking your papers…",
    "arena": "Finding the battle…",
    "radar": {
      "aria": "Radar scope searching for opponents",
      "searching": "Searching for opponents…",
      "found": "Opponents found!",
      "captains": "Captains found",
      "elapsed": "Search time",
      "cancel": "Cancel search"
    },
    "tips": {
      "0": "A shell that lands on the citadel does twice the damage. Show them your bow, not your side.",
      "1": "Firing blooms your ship for twenty seconds: everyone on the far side sees the flash.",
      "2": "Torpedoes arm two hundred metres out and run six kilometres. Lead the target, then wait.",
      "3": "A ring nobody stands in stays as it was. Half a capture left behind is half a capture kept.",
      "4": "Land blocks sight. A hull behind an island is a hull the enemy is not shooting at.",
      "5": "The repair party puts out every fire at once, but only three times a battle.",
      "6": "Sound takes its time: a gun two kilometres off is seen before it is heard.",
      "7": "Bow and stern saturate. A ship cannot be sunk through its bow alone."
    }
  },
  "charts": {
    "open": "Open water",
    "archipelago": "Archipelago",
    "strait": "The Strait",
    "atoll": "Atoll",
    "fjord": "Fjord",
    "twins": "Twin Peaks",
    "shoals": "Shoals",
    "headland": "Headland",
    "delta": "Delta",
    "crescent": "Crescent",
    "sound": "The Sound"
  },
  "sortie": {
    "title": "Put to sea",
    "charts": "Charts in rotation",
    "training": "Training sortie",
    "sail": "Sail",
    "chosen": "Chosen",
    "minutes": "{n} min",
    "captains": { "one": "one captain at sea", "other": "{count} captains at sea" },
    "nobody": "Nobody at sea yet — your arrival starts the battle",
    "offline": "Who is at sea could not be read.",
    "pinned": "This server sails {mode} only.",
    "pinnedRotate": "This server draws the rules for each battle.",
    "bracket": {
      "junior": "Your hull sails with tiers I–II.",
      "senior": "Your hull sails with tiers III–IV.",
      "flag": "Your hull sails with tier V and above.",
      "open": "Every tier sails together on this server."
    }
  },
  "auth": {
    "brand": "Admiralty",
    "working": "…",
    "unreachable": "Could not reach the server. Try again in a moment.",
    "showPassword": "Show password",
    "hidePassword": "Hide password"
  },
  "join": {
    "enlisted": "Enlisted",
    "welcome": "Welcome aboard",
    "signIn": "Sign in",
    "register": "Register",
    "nickname": "Call sign",
    "nicknamePlaceholder": "Call sign (3–16)",
    "email": "Email",
    "password": "Password",
    "passwordNewPlaceholder": "Password (8+)",
    "repeatPassword": "Repeat password",
    "agree": "I agree to the terms and the privacy policy",
    "agreeLead": "I agree to the",
    "agreeAnd": "and",
    "terms": "Terms",
    "privacy": "Privacy",
    "createAccount": "Create account",
    "back": "Back",
    "forgot": "Forgot password?",
    "forgotTitle": "Reset",
    "forgotSend": "Send link",
    "forgotSent": "If that email exists, a reset link is on its way.",
    "backToSignIn": "Back to sign in"
  },
  "verify": {
    "title": "Verify email",
    "working": "Confirming…",
    "ok": "Confirmed",
    "okLine": "Your account is ready.",
    "failed": "Link failed",
    "unreachable": "Could not reach the server. Try the link again in a moment.",
    "continue": "Continue",
    "signIn": "Sign in",
    "gateTitle": "Confirm email",
    "awaiting": "Check your mail",
    "gateLine": "Open the link we sent before you board.",
    "yourAddress": "your address",
    "resend": "Send again",
    "devLink": "No mailer on this stack. The link:"
  },
  "reset": {
    "title": "New password",
    "newPassword": "New password",
    "newPlaceholder": "New password ({count}+)",
    "repeat": "Repeat password",
    "mismatch": "The two do not match.",
    "submit": "Set password",
    "cancel": "Cancel",
    "ok": "Changed",
    "okLine": "Every device was signed out.",
    "signIn": "Sign in"
  },
  "notFound": {
    "title": "Lost at sea",
    "code": "404",
    "hint": "Nothing at this address.",
    "back": "Back to harbour"
  },
  "notices": {
    "title": "Noticeboard",
    "tabs": { "news": "Notices", "faq": "Questions" },
    "loading": "Reading the board…",
    "empty": "Nothing posted yet.",
    "failed": "The board could not be read.",
    "back": "All notices",
    "more": "More"
  },
  "consent": {
    "title": "Cookies and storage",
    "body": "We always keep what sign-in and payments need. Settings such as language and sound are only remembered on this device if you agree.",
    "policy": "Cookie policy",
    "acceptAll": "Accept all",
    "rejectAll": "Reject non-essential",
    "customise": "Choose",
    "settingsTitle": "Cookie settings",
    "settingsLead": "Pick what may be stored on this device. You can change this at any time.",
    "settingsLink": "Cookie settings",
    "save": "Save choices",
    "alwaysOn": "Always on",
    "noneUsed": "Not used",
    "details": "{count} items",
    "col": { "name": "Name", "kind": "Type", "purpose": "Purpose", "duration": "Kept" },
    "kind": { "cookie": "Cookie", "local": "Local storage", "session": "Session storage" },
    "cat": {
      "necessary": { "name": "Necessary", "desc": "Sign-in, payments and remembering this choice. The game cannot work without them." },
      "preferences": { "name": "Preferences", "desc": "Language, sound and picture settings, and which tips you have already seen." },
      "analytics": { "name": "Analytics", "desc": "Counting visits to improve the game. None are used today." },
      "marketing": { "name": "Marketing", "desc": "Measuring adverts. None are used today." }
    },
    "items": {
      "access": { "purpose": "Keeps you signed in for the current visit.", "duration": "15 minutes" },
      "refresh": { "purpose": "Renews your sign-in without asking for the password again.", "duration": "3 days" },
      "session": { "purpose": "Remembers that this browser signed in, so the game opens straight away.", "duration": "Until you sign out" },
      "consent": { "purpose": "Remembers your answer on this page.", "duration": "Until the policy changes" },
      "payment": { "purpose": "Finds your order when you return from the payment page.", "duration": "This tab" },
      "settings": { "purpose": "Volume, aiming and picture quality.", "duration": "Until cleared" },
      "locale": { "purpose": "Your language.", "duration": "Until cleared" },
      "sound": { "purpose": "Whether the landing page plays music.", "duration": "Until cleared" },
      "howto": { "purpose": "Whether the how-it-works strip in the tech tree is shown.", "duration": "Until cleared" }
    }
  },
  "legal": {
    "title": "Legal document",
    "loading": "Fetching the document…",
    "missing": "This document has not been published yet. Write to us and we will send it over."
  },
  "settings": {
    "title": "Settings",
    "short": "Settings",
    "keys": "M mutes the sound in battle. Esc closes this.",
    "sound": {
      "title": "Sound",
      "volume": "Volume",
      "music": "Music",
      "sfx": "Interface sounds",
      "radio": "Radio",
      "mute": "Mute everything"
    },
    "helm": {
      "title": "Helm and guns",
      "sensitivity": "Aim sensitivity",
      "invert": "Invert the tilt"
    },
    "graphics": {
      "title": "Graphics",
      "quality": "Quality",
      "note": "Applies when a scene is next built: leave the harbour or the battle and come back.",
      "reduceMotion": "Less motion: no tarps, no dealing cards, no flying coins",
      "auto": "Auto",
      "lean": "Lean",
      "full": "Full"
    },
    "help": {
      "title": "Help",
      "replayTour": "Replay the harbour tour",
      "replayed": "The tour starts again in the harbour."
    }
  },
  "restartConfirm": {
    "title": "Restart the fleet",
    "working": "Selling the fleet…",
    "done": "Done. The fleet is sold and your credits are back in the purse.",
    "back": "{pct}% of the fleet's worth came back: {silver} credits.",
    "expired": "This link is invalid, expired or already used. Ask for a new one from your papers.",
    "badLink": "This link is incomplete. Ask for a new one from your papers.",
    "failed": "The restart did not go through.",
    "toHarbour": "To the harbour"
  },
  "tutorial": {
    "title": "Harbour tour",
    "next": "Next",
    "finish": "Aye aye",
    "waiting": "Go on, I will wait.",
    "skip": "Skip the tour",
    "skipConfirm": "Press again to skip",
    "progress": "Tour {done}/{total}",
    "speaker": { "admiral": "Admiral", "mate": "First mate" },
    "welcome": {
      "l1": "Welcome aboard, Captain. This harbour is yours, and so is the ship at anchor in it.",
      "l2": "I am your first mate. A few minutes will show you where everything is."
    },
    "shipyard": { "l1": "The shipyard: fit guns, buy hulls, paint her. Tap it and have a look." },
    "shop": { "l1": "The Chandler sells seals and boosters. Tap it to see what is on the shelves." },
    "sortie": { "l1": "Now the sea. Put to sea and take your first sortie." },
    "done": { "l1": "Well done, Captain. The rest is up to you. You can replay this tour from Settings." }
  },
  "home": {
    "orders": "Orders: {done}/{total}",
    "arena": {
      "captains": {
        "one": "one captain",
        "other": "{count} captains"
      }
    }
  },
  "profile": {
    "title": "Service Record",
    "reading": "Reading the service record…",
    "unavailable": "The service record is unavailable.",
    "toNextRank": "To next rank",
    "xpProgress": "{have} / {need} XP",
    "topRank": "Top rank · {have} XP",
    "lifetime": {
      "title": "Service record",
      "battles": "Battles",
      "wins": "Wins",
      "winRate": "{percent}% won",
      "kills": "Sunk",
      "damage": "Damage",
      "avgDamage": "Damage per battle",
      "xp": "Experience earned"
    },
    "ships": {
      "title": "Ships' logs",
      "elite": "Elite"
    },
    "season": {
      "points": "Rating points",
      "note": "Season {number} · {ends}",
      "endsToday": "ends today",
      "daysLeft": "{count} days left"
    },
    "orders": {
      "title": "Standing Orders",
      "daily": "Daily",
      "weekly": "Weekly",
      "claim": "Claim",
      "claimed": "Claimed",
      "ready": "Ready",
      "claimFailed": "The reward could not be claimed.",
      "none": "No orders posted."
    },
    "passXp": {
      "title": "Season pass XP",
      "aria": "{count} season pass XP"
    },
    "tasks": {
      "title": "Campaigns",
      "tab": { "monthly": "Monthly", "super": "Super", "global": "Community" },
      "intro": {
        "monthly": "Every captain holds all of these. They start over on the first of the month, UTC.",
        "super": "Long goals that never start over. Progress counts from your first action after one is posted.",
        "global": "One total for the whole fleet. When it is met, everyone who gave their share takes the reward."
      },
      "ready": { "one": "{count} ready", "other": "{count} ready" },
      "none": "No campaigns posted.",
      "community": "Fleet: {value} / {target}",
      "carriedMonth": "From an earlier period",
      "carriedGlobal": "Goal met earlier",
      "yourShare": "Your share: {value} of {min} needed",
      "shareMet": "Your share: {value}, enough to take part",
      "participants": { "one": "{count} captain taking part", "other": "{count} captains taking part" },
      "reached": "Goal met"
    },
    "papers": "Papers"
  },
  "engagement": {
    "title": "Rewards",
    "blurb": "A reward for every day in port, and for every milestone of your career.",
    "livery": "Livery",
    "claimFailed": "The reward could not be claimed."
  },
  "calendar": {
    "title": "Daily Rewards",
    "reading": "Reading the calendar…",
    "day": "Day {day}",
    "progress": "{done} / {total} days",
    "claim": "Claim day {day}",
    "tomorrow": "Come back tomorrow",
    "note": "One reward a day, the day turning over at midnight UTC. A day you miss is not lost: the next claim pays the next tile."
  },
  "achievements": {
    "title": "Achievements",
    "reading": "Reading the ledger of deeds…",
    "tier": "Tier {tier} of {tiers} · {value} / {target}",
    "claim": "Claim",
    "complete": "Complete",
    "names": {
      "victor": "Victor",
      "gunnery": "Gunnery",
      "sea_dog": "Sea Dog",
      "rising_officer": "Rising Officer",
      "naval_architect": "Naval Architect",
      "fleet_owner": "Fleet Owner",
      "ladder_climber": "Ladder Climber",
      "hunter": "Hunter",
      "master_of_the_line": "Master of the Line"
    },
    "stats": {
      "battles_won": "Battles won",
      "battles_played": "Battles fought",
      "damage_dealt": "Damage dealt",
      "ships_sunk": "Ships sunk",
      "rank": "Rank rung",
      "research_nodes": "Research completed",
      "hulls_owned": "Hulls bought",
      "season_rating": "Season rating",
      "elite_hulls": "Elite hulls"
    }
  },
  "papers": {
    "title": "The Captain's Papers",
    "tabs": {
      "account": "Account",
      "billing": "Billing address",
      "invoices": "Invoices",
      "purchases": "Purchases"
    },
    "account": {
      "identity": "Identity",
      "callSign": "Call sign",
      "fullName": "Full name",
      "saveCallSign": "Save call sign",
      "saveName": "Save name",
      "callSignShape": "{min}–{max} letters, digits, dots, dashes or underscores — start and end with a letter or digit.",
      "email": "Email",
      "verified": "Verified",
      "unverified": "Unverified",
      "resend": "Send verification again",
      "devLink": "No mailer configured on this stack, so here is the link:",
      "enlisted": "Enlisted {date}",
      "preferences": "Language and currency",
      "language": "Language",
      "currency": "Currency",
      "password": "Change password",
      "currentPassword": "Current password",
      "newPassword": "New password",
      "repeatPassword": "Repeat new password",
      "passwordMismatch": "The new password and its repeat do not match.",
      "passwordDone": "Password changed. Signing you out…",
      "changePassword": "Change password",
      "danger": "Danger zone",
      "dangerNote": "Irreversible. Every invoice is archived first; nothing else survives.",
      "deleteOpen": "Delete my account",
      "typeEmail": "Type {email} to confirm",
      "deleteConfirm": "Delete my account"
    },
    "restart": {
      "title": "Restart the fleet",
      "note": "Sell the fleet and start again. {pct}% of what it is worth comes back as credits. This cannot be undone.",
      "worth": "Fleet worth",
      "back": "Comes back",
      "keeps": "Kept: {list}.",
      "keep": {
        "seals": "seals",
        "paid_hulls": "hulls and parts bought with seals",
        "cosmetics": "paint and ensigns",
        "boosters": "boosters",
        "premium_account": "premium account",
        "rank_and_record": "rank and record",
        "season_rating": "season rating",
        "purchase_history": "purchase history"
      },
      "understand": "I understand the fleet is sold and this cannot be undone",
      "request": "Send me the confirmation link",
      "checkEmail": "Check your e-mail: the link works for {min} minutes and once.",
      "devLink": "No mailer configured on this stack, so here is the link",
      "cooldown": "You can restart again on {date} (one restart every {days} days)."
    },
    "billing": {
      "title": "Billing address",
      "saved": "Address saved."
    },
    "invoices": {
      "title": "Invoices",
      "reading": "Reading the invoices…",
      "empty": "No invoices yet.",
      "pdf": "PDF"
    },
    "purchases": {
      "title": "Purchases",
      "reading": "Reading the ledger…",
      "empty": "No purchases yet.",
      "kind": {
        "all": "All",
        "credits": "Credits",
        "diamonds": "Seals"
      }
    },
    "art": {
      "noInvoices": "An empty invoice tray",
      "noPurchases": "An empty ledger on the counter"
    },
    "field": {
      "show": "Show",
      "hide": "Hide"
    },
    "pager": {
      "label": "Pages",
      "prev": "Previous page",
      "next": "Next page"
    }
  },
  "shipyard": {
    "title": "Shipyard",
    "sections": "Shipyard sections",
    "opening": "Opening the shipyard gates…",
    "closed": "The shipyard is closed.",
    "noAnswer": "The shipyard is not answering.",
    "retry": "That did not work. Try again.",
    "tabs": {
      "fit": "Fit out",
      "hulls": "Ships",
      "modules": "Modules",
      "looks": "Livery",
      "sell": "Sell",
      "research": "Research"
    },
    "atSea": "At sea",
    "sell": {
      "opening": "Opening the counter…",
      "noAnswer": "The counter is not answering.",
      "lead": "The yard buys back what you paid seals for: now at {instant}% of its value, or {delayed}% if you wait {hours} hours.",
      "waiting": "Waiting for payment",
      "held": "Yours to sell",
      "history": "Past sales",
      "empty": "Nothing you bought with seals is waiting to be sold.",
      "sell": "Sell",
      "locked": "Not now",
      "sheetTitle": "Sell",
      "quantity": "How many",
      "less": "One fewer",
      "more": "One more",
      "ofHeld": "of {held}",
      "value": "Worth",
      "how": "How to sell",
      "mode": {
        "instant": "Now, {pct}%",
        "delayed": "In {hours} h, {pct}%"
      },
      "modeNote": {
        "instant": "Paid at once.",
        "delayed": "Paid after {hours} hours. You can call it back until then."
      },
      "confirm": "Sell",
      "paysIn": "Pays in {hours} h {minutes} min",
      "paying": "Paying out…",
      "sold": "{name} sold.",
      "listed": "{name} is on the counter. It pays out later.",
      "cancelled": "Sale called back. The item is yours again.",
      "status": {
        "settled": "Paid",
        "cancelled": "Called back"
      },
      "why": {
        "not_sold_for_seals": "Only what you bought with seals can be sold. Gifts, rewards and credit purchases cannot.",
        "active_ship": "This is the ship in command. Put another to sea first.",
        "equipped": "You are wearing it. Wear another first.",
        "fitted": "It is mounted on a ship. Take it off in Fit out first.",
        "none_left": "No charges left.",
        "worthless": "It is worth less than one seal."
      }
    },
    "stamp": {
      "command": "In command"
    },
    "shelf": {
      "title": "Your ships",
      "aria": "Your ships"
    },
    "fit": {
      "planAria": "Deck plan: gun mounts and torpedo tubes, bow to the right",
      "bow": "Bow",
      "mountAria": "Gun mount {number}, {place}",
      "figures": "What she can do",
      "previewing": "Showing the change",
      "guns": "Main guns · {count} mounts",
      "hull": "Hull",
      "stat": {
        "perMinute": "Damage a minute",
        "salvo": "Full salvo",
        "reload": "Reload",
        "range": "Gun range",
        "hp": "Hit points",
        "speed": "Top speed",
        "turn": "Turn rate",
        "concealment": "Seen from",
        "fish": "Damage a torpedo",
        "torpReload": "Reload a bank",
        "torpRange": "Torpedo range",
        "torpSpeed": "Torpedo speed"
      },
      "unit": {
        "km": "{value} km",
        "s": "{value} s",
        "speed": "{value} m/s",
        "turn": "{value}°/s"
      },
      "place": {
        "bow": "bow",
        "midships": "midships",
        "stern": "stern"
      },
      "mountTitle": "Mount {number} · {place}",
      "fitted": "Fitted",
      "gunStat": {
        "shell": "Shell",
        "reload": "Reload",
        "range": "Range",
        "perMinute": "/min"
      },
      "fitHere": "Fit on mount {number}",
      "fitAll": "Fit on every mount",
      "fittedAll": "{name} fitted on every mount.",
      "torpedoes": "Torpedoes",
      "torpLead": "{launchers} banks of {tubes} tubes, one on each beam. They come with the hull — there is nothing to fit.",
      "torpHow1": "Turn your side to the enemy: a bank only fires across the beam it is on, never ahead or astern.",
      "torpHow2": "Hold F: the fan is drawn on the sea from the bank that bears on your aim. Release F to fire.",
      "torpHow2Touch": "Tap the torpedo button on the right of the screen when it says it bears.",
      "torpHow3": "Aim ahead of a moving ship: a torpedo is slow and runs straight, so lead the target by where it will be.",
      "torpUpgrade": "Bigger banks come with higher-tier destroyers. Researching this hull's Torpedoes B improves them further.",
      "howTo": "How to fire",
      "noTorpedoes": "This ship carries no torpedoes. Only destroyers have tubes — their guns are lighter for it.",
      "modules": "Modules · {used}/{max}",
      "noModules": "No modules yet. Each one changes a figure above; up to three can be fitted.",
      "moreModules": "Buy modules",
      "slot": "Module {number}",
      "empty": "Empty",
      "fitModule": "Fit",
      "notResearched": "Not researched",
      "unfitModule": "Unfit",
      "controls": "In battle",
      "keys": {
        "mouse": "Mouse",
        "aim": "Aim the guns where you look",
        "fire": "Click / Space",
        "fireText": "Fire every gun that is loaded and bears",
        "torpText": "Torpedoes: hold to lay the fan on the sea, release to fire",
        "helm": "Throttle and rudder",
        "touchAim": "Right side",
        "touchFire": "Hold right",
        "touchTorp": "Tube button",
        "touchHelm": "Left side"
      },
      "lengthM": "{value} m",
      "schedule": "Gun mounts"
    },
    "needsResearch": "Research required",
    "putToSea": "Put to Sea",
    "fitting": {
      "title": "Fitting · {hull}",
      "note": "Turrets run bow to stern. No more than {max} modules.",
      "mount": "Turret {number}",
      "modules": "Modules",
      "noModules": "No modules yet — they are on the Modules tab.",
      "tooMany": "No more than {max} modules."
    },
    "classOnly": "Class only: {class}",
    "class": {
      "destroyer": "destroyer",
      "cruiser": "cruiser",
      "battleship": "battleship"
    },
    "looks": {
      "shipName": "Ship's name",
      "shipNameLabel": "What your ship is called",
      "shipNameHint": "{min} to {max} characters; a letter or digit at each end.",
      "firstFree": "The first name is free.",
      "renamePrice": "Renaming costs {count} seals.",
      "name": "Name her",
      "rename": "Rename",
      "renamed": "The ship is now “{name}”.",
      "renameConfirm": "Rename to “{name}”",
      "livery": "Livery",
      "flag": "Ensign",
      "painted": "Painted",
      "paint": "Paint",
      "flown": "Flown",
      "raise": "Raise",
      "rewardNotForSale": "A reward — not for sale",
      "reward": "Reward",
      "bought": "“{name}” bought.",
      "equipped": "“{name}” — on the ship.",
      "buyConfirm": "Buy “{name}”"
    },
    "buy": {
      "bought": "“{name}” bought.",
      "selected": "“{name}” puts to sea.",
      "buyItem": "Buy “{name}”"
    },
    "topup": {
      "title": "Top up seals"
    },
    "time": {
      "hoursMinutes": "{hours} h {minutes} min",
      "hours": "{hours} h",
      "minutesSeconds": "{minutes} min {seconds} s",
      "minutes": "{minutes} min",
      "seconds": "{seconds} s"
    },
    "hull": {
      "destroyer_t1": {
        "name": "Destroyer I",
        "blurb": "A training destroyer. Fast, light, three tubes a side, forgives mistakes."
      },
      "destroyer_t2": {
        "name": "Destroyer II",
        "blurb": "Strengthened hull and new engines: +10% hit points, a lower silhouette, longer-legged fish — and three seconds more between fans."
      },
      "destroyer_t3": {
        "name": "Destroyer III",
        "blurb": "Quadruple banks and 20 m/s, bought with the rudder: a wider fan, a slower turn, seventy-two seconds to reload."
      },
      "destroyer_t4": {
        "name": "Destroyer IV",
        "blurb": "Five tubes a side and the hardest ship in the game to see — but it turns worst of the line and waits eighty-four seconds for the next salvo."
      },
      "cruiser_t1": {
        "name": "Cruiser I",
        "blurb": "Three turrets and twice a destroyer’s hit points. No tubes at all. Slower, but takes a beating."
      },
      "cruiser_t2": {
        "name": "Cruiser II",
        "blurb": "Armour belt and forced boilers: +12% hit points and the handiest rudder in the line, for a ship that is slower to answer a bell."
      },
      "cruiser_t3": {
        "name": "Cruiser III",
        "blurb": "Where the line goes heavy: 37 000 hit points and better concealment, paid for with the handling tier II was proud of."
      },
      "cruiser_t4": {
        "name": "Cruiser IV",
        "blurb": "A heavy cruiser proper — 45 000 hit points, the best concealment in the line, and the turn rate of a small battleship."
      },
      "battleship_t1": {
        "name": "Battleship I",
        "blurb": "Sixty thousand hit points and 10 km of reach. It cannot run, cannot hide and cannot be ignored."
      },
      "battleship_t2": {
        "name": "Battleship II",
        "blurb": "+17% hit points and half a knot, for a rudder that answers slower still."
      },
      "battleship_t3": {
        "name": "Battleship III",
        "blurb": "82 000 hit points and 12 m/s, with an engine room that takes its time about a bell."
      },
      "battleship_t4": {
        "name": "Battleship IV",
        "blurb": "Ninety-five thousand hit points at 13 m/s, turning under four degrees a second: every heading is a commitment that outlives its reason."
      },
      "battleship_sovereign": {
        "name": "Sovereign",
        "blurb": "Bought outright for seals, her triple 380s already shipped. Eighty-eight thousand hit points at 14 m/s: lighter and quicker on the helm than Battleship IV, and seen from further off. No research to grow, and nothing aboard a credit path cannot also reach."
      }
    },
    "turret": {
      "twin_120": {
        "name": "Twin 120 mm",
        "blurb": "The standard mounting, fitted to every ship afloat. Quick to reload, light shell."
      },
      "twin_130": {
        "name": "Twin 130 mm",
        "blurb": "Destroyers only. Faster to fire and to train than anything on a cruiser, and scatters more for it."
      },
      "twin_150": {
        "name": "Twin 150 mm",
        "blurb": "Cruisers only. Heavier shell, longer reach, slower to reload."
      },
      "triple_150": {
        "name": "Triple 150 mm",
        "blurb": "Cruisers only. Half again the shell of a twin, at eight and a half seconds and a slower train."
      },
      "twin_150_premium": {
        "name": "Twin 150 mm “Admiral’s”",
        "blurb": "The same mounting, polished: 5% faster reload and gilded fittings. Nothing else is different, and nothing else should be."
      },
      "twin_280": {
        "name": "Twin 280 mm",
        "blurb": "Battleships only. Two seconds off the stock reload and a heavier shell, for a little less muzzle velocity and 300 m of reach."
      },
      "triple_380": {
        "name": "Triple 380 mm",
        "blurb": "Battleships only. Eighteen thousand in a broadside every thirty-two seconds — and the slowest training turret in the game, so choose the target once."
      },
      "triple_120": {
        "name": "Triple 120 mm",
        "blurb": "Destroyer II's own Guns B. Three barrels for one, three seconds to reload — a heavier fist than the stock mounting, trained just as fast."
      },
      "quad_130": {
        "name": "Quad 130 mm",
        "blurb": "Destroyer III's own Guns B. Four barrels and a bigger shell than anything else this hull carries, at the cost of a slower train."
      },
      "twin_138": {
        "name": "Twin 138 mm",
        "blurb": "Destroyer IV's own Guns B. The line's heaviest destroyer mounting — more shell, more reach, faster than the stock pair to swing onto a new target."
      },
      "twin_140": {
        "name": "Twin 140 mm",
        "blurb": "Cruiser I's own Guns B. A heavier shell than the stock mounting for a cruiser only just off the yard."
      },
      "triple_155": {
        "name": "Triple 155 mm",
        "blurb": "Cruiser IV's own Guns B. The heaviest gun a cruiser carries — a slow train is the whole of its cost."
      },
      "twin_240": {
        "name": "Twin 240 mm",
        "blurb": "Battleship I's own Guns B. A faster-training alternative to the stock mounting, for a little less shell."
      },
      "twin_305": {
        "name": "Twin 305 mm",
        "blurb": "Battleship II's own Guns B. More shell and better dispersion than the stock pair, at a reload measured in tens of seconds either way."
      }
    },
    "module": {
      "research": {
        "hull": {
          "name": "Hull refit",
          "blurb": "Thicker plating and a better-balanced rudder for this hull alone: more to sink, a tighter turn, seen later, fire and flooding put out sooner."
        },
        "propulsion": {
          "name": "Propulsion refit",
          "blurb": "Retuned boilers and a cleaner screw for this hull alone: quicker off the mark and a little faster at the top."
        },
        "fire_control": {
          "name": "Fire control refit",
          "blurb": "A longer-base rangefinder and better-matched charges for this hull alone: tighter groups and a flatter shell."
        },
        "torpedoes": {
          "name": "Torpedo refit",
          "blurb": "Reworked tubes and warheads for this hull alone: a faster reload and a heavier hit, and on the bigger boats another tube."
        }
      },
      "engine_boost": {
        "name": "Engine Boost",
        "blurb": "+8% top speed."
      },
      "rudder_kit": {
        "name": "Reinforced Rudders",
        "blurb": "+15% rate of turn."
      },
      "fire_control": {
        "name": "Fire Control System",
        "blurb": "−15% shell dispersion."
      },
      "damage_control": {
        "name": "Damage Control Party",
        "blurb": "Fires and flooding last 30% less."
      },
      "camouflage_paint": {
        "name": "Camouflage Scheme",
        "blurb": "−12% detection range: harder to see, everywhere."
      },
      "oxygen_torpedoes": {
        "name": "Oxygen Warheads",
        "blurb": "Destroyer tubes: +12% damage, +10% torpedo speed, but 15% slower to reload."
      },
      "torpedo_loaders": {
        "name": "Trained Loaders",
        "blurb": "Destroyer tubes: −15% reload. Nothing at all on a ship without them."
      },
      "premium_repair": {
        "name": "Reserve Repair Kit",
        "blurb": "A fourth repair-party charge each battle."
      }
    },
    "researchNode": {
      "r_destroyer_t2": {
        "name": "Destroyer II"
      },
      "r_destroyer_t3": {
        "name": "Destroyer III"
      },
      "r_destroyer_t4": {
        "name": "Destroyer IV"
      },
      "r_cruiser_t1": {
        "name": "Cruiser I"
      },
      "r_cruiser_t2": {
        "name": "Cruiser II"
      },
      "r_cruiser_t3": {
        "name": "Cruiser III"
      },
      "r_cruiser_t4": {
        "name": "Cruiser IV"
      },
      "r_battleship_t1": {
        "name": "Battleship I"
      },
      "r_battleship_t2": {
        "name": "Battleship II"
      },
      "r_battleship_t3": {
        "name": "Battleship III"
      },
      "r_battleship_t4": {
        "name": "Battleship IV"
      }
    },
    "openTree": "Open research tree",
    "field": {
      "class": "Class",
      "tier": "Tier",
      "battery": "Main battery"
    }
  },
  "battle": {
    "report": {
      "rank": "Rank"
    },
    "scene": {
      "victory": "A cruiser steaming out of the smoke after a won action",
      "defeat": "A ship burning on a grey sea",
      "promotion": "An officer receiving his new rank at the rail"
    },
    "promoted": "Promoted!",
    "toNext": "{count} experience to the next rank",
    "questDone": "Order complete: {name}",
    "title": "Admiralty",
    "phase": {
      "waiting": "Waiting for captains",
      "countdown": "Battle begins in",
      "battle": "Battle",
      "results": "Next battle in"
    },
    "outcome": {
      "victory": "Victory",
      "defeat": "Defeat",
      "draw": "Draw",
      "over": "Battle over"
    },
    "curtain": {
      "forming": "The fleets are forming",
      "stations": "Battle stations",
      "waitingNote": "Waiting for the first captain to put to sea."
    },
    "modes": {
      "name": {
        "domination": "Domination",
        "encounter": "Encounter",
        "annihilation": "Annihilation",
        "epicentre": "Epicentre",
        "convoy": "Convoy"
      },
      "blurb": {
        "domination": "Hold the rings. First to {cap} points, or the last fleet afloat.",
        "encounter": "One ring in the middle. First to {cap} points, or the last fleet afloat.",
        "annihilation": "No rings. Sink them all, or lead on sinkings when the clock runs out.",
        "epicentre": "Three rings, one inside the other; the inner is worth most. First to {cap}.",
        "convoy": "Three merchantmen sail for the port behind the enemy line. Escort them home, or sink them."
      }
    },
    "convoy": {
      "aria": "The convoy",
      "afloat": "{n} at sea",
      "home": "{n} home",
      "sunk": "{n} sunk",
      "feedSank": "sank",
      "feedHome": "reached port"
    },
    "lockHint": "Click to take the helm",
    "status": {
      "fire": "Fire, {seconds} s",
      "flood": "Flooding, {seconds} s"
    },
    "detected": {
      "label": "Spotted",
      "note": "The enemy can see you."
    },
    "repair": {
      "aria": "Repair party, {count} left"
    },
    "hull": "Hull",
    "guns": "Guns",
    "sunkNote": "Sunk — spectating until the next battle.",
    "hints": {
      "touch": "Left: steer · Right: aim & fire · pinch: zoom · Torpedoes on the panel",
      "keys": "W/S throttle · A/D rudder · mouse aims · click / Space fires · F torpedoes (hold to aim the fan, release to fire) · R repair · wheel zoom · Z or Shift raises the sight · RMB free look"
    },
    "resultsAria": "Battle results",
    "lesson": {
      "skip": "Skip to battle",
      "toSea": "To battle",
      "helm": { "title": "Take the helm", "keys": "Click the sea. The mouse is yours until Esc.", "touch": "Left thumb steers, right thumb aims." },
      "throttle": { "title": "Make way", "keys": "W ahead, S astern. The telegraph is at the bottom.", "touch": "Push the left stick forward." },
      "rudder": { "title": "Put the helm over", "keys": "A and D. A ship answers slowly — hold it.", "touch": "Push the left stick to a side." },
      "aim": { "title": "Find the contact", "keys": "Turn the camera until a hull sits under the mark. The plate names it.", "touch": "Drag the right side until a hull sits under the mark." },
      "fire": { "title": "Open fire", "keys": "Click or Space. Watch the flight time by the range, and where the splashes fall.", "touch": "Tap the fire button. Watch where the splashes fall." },
      "glasses": { "title": "Raise the glasses", "keys": "Shift or Z. Long shots are laid from the bridge sight.", "touch": "Pinch in past the nearest step." },
      "torpedoes": { "title": "Torpedoes", "keys": "Hold F to see the fan, release to launch. They are slow: lead the target.", "touch": "Hold the torpedo button to see the fan, release to launch." },
      "sink": { "title": "Sink her", "keys": "Broadside for damage, bow-on to take less. R calls the repair party when you burn.", "touch": "Broadside for damage, bow-on to take less. The repair button when you burn." },
      "over": { "title": "Well done, captain", "note": "The fleet is waiting. Put to sea." }
    },
    "story": {
      "guns": "Shells on target",
      "citadels": "Citadels",
      "torpedoes": "Torpedoes",
      "dealt": "Damage",
      "taken": "Taken",
      "fire": "Burnt off them",
      "flood": "Flooded out of them",
      "capture": "In the ring",
      "afloat": "Afloat"
    },
    "pay": {
      "base": "Put to sea",
      "damage": "Damage",
      "kills": "Ships sunk",
      "capture": "Holding the ring",
      "win": "Victory",
      "survival": "Brought her home"
    },
    "boost": {
      "credits": "Boost {mult} +{amount}",
      "xp": "Boost {mult} +{amount} XP"
    },
    "next": {
      "research": "Next: research {name}",
      "buy": "Next: buy {name}"
    },
    "earnedCredits": "+{count} credits",
    "earnedXp": "+{count} XP",
    "board": {
      "captain": "Captain",
      "ship": "Ship",
      "damage": "Damage",
      "sunk": "Sunk",
      "credits": "Credits"
    },
    "failed": "The sea could not be drawn here.",
    "backToHarbour": "Back to harbour",
    "torpedoes": {
      "label": "Torpedoes",
      "aria": "Torpedo launchers",
      "mount": "Launcher {index}",
      "ready": "ready",
      "none": "No tubes",
      "away": "Torpedoes away",
      "hit": "Torpedo hit!",
      "taken": "Torpedo!",
      "incoming": {
        "seconds": "{seconds} s",
        "aria": "Torpedo incoming {bearing}, {seconds} seconds to impact",
        "more": "+{count} more",
        "turn": "Turn toward the wake",
        "bearing": {
          "bow": "ahead",
          "port": "to port",
          "starboard": "to starboard",
          "astern": "astern"
        }
      }
    },
    "zones": {
      "name": {
        "west": "West",
        "centre": "Centre",
        "east": "East",
        "north": "North",
        "south": "South",
        "lagoon": "Lagoon",
        "inner": "Inner ring",
        "middle": "Middle ring",
        "outer": "Outer ring",
        "port": "Port"
      },
      "aria": "Capture zones",
      "taken": "{zone} taken",
      "lost": "{zone} lost",
      "holding": "Holding {zone}",
      "capturing": "Taking {zone}",
      "losing": "Losing {zone}",
      "contested": "{zone} contested",
      "neutral": "{zone} — nobody holds it",
      "enemyHeld": "{zone} held by the enemy"
    },
    "score": {
      "aria": "Battle points",
      "cap": "first to {count}",
      "ally": "Your points",
      "enemy": "Enemy points"
    },
    "chart": "Chart",
    "target": {
      "burning": "Burning",
      "flooding": "Flooding",
      "noBearing": "No bearing",
      "outOfRange": "Out of range",
      "aria": "Target {name}, {class}, range {range} metres, {aspect}",
      "aspect": {
        "bow": "End on",
        "angled": "Angled",
        "broadside": "Broadside"
      }
    },
    "helm": {
      "label": "Helm",
      "speed": "Speed",
      "heading": "Heading",
      "throttle": "Telegraph",
      "rudder": "Rudder"
    },
    "sound": {
      "off": "Sound off · M",
      "on": "Sound on"
    },
    "dealt": {
      "aria": "{amount} damage dealt this battle"
    },
    "gunnery": {
      "label": "Gunnery",
      "onContact": "on contact",
      "onSea": "on sea",
      "aria": "Guns laid at {range} metres, {source}",
      "turret": {
        "reloading": "Loading, {seconds}s",
        "turning": "Loaded, training onto the aim",
        "onTarget": "Loaded, on target",
        "cannotBear": "Cannot bear"
      }
    },
    "condition": {
      "label": "Condition",
      "hull": "Hull",
      "sound": "All sound"
    },
    "sight": {
      "label": "Bridge sight",
      "magnification": "{factor}×",
      "exit": "Lower glasses",
      "exitKeys": "Z or Shift",
      "aria": "Bridge sight, {factor} times magnification, guns laid at {range} metres"
    }
  },
  "ranks": {
    "cadet": {
      "name": "Cadet",
      "abbr": "CDT"
    },
    "midshipman": {
      "name": "Midshipman",
      "abbr": "MID"
    },
    "ensign": {
      "name": "Ensign",
      "abbr": "ENS"
    },
    "sub_lieutenant": {
      "name": "Sub-Lieutenant",
      "abbr": "SLT"
    },
    "lieutenant": {
      "name": "Lieutenant",
      "abbr": "LT"
    },
    "lieutenant_commander": {
      "name": "Lieutenant Commander",
      "abbr": "LCDR"
    },
    "commander": {
      "name": "Commander",
      "abbr": "CDR"
    },
    "captain": {
      "name": "Captain",
      "abbr": "CAPT"
    },
    "senior_captain": {
      "name": "Senior Captain",
      "abbr": "SCPT"
    },
    "flag_captain": {
      "name": "Flag Captain",
      "abbr": "FCPT"
    },
    "commodore": {
      "name": "Commodore",
      "abbr": "CDRE"
    },
    "rear_admiral": {
      "name": "Rear Admiral",
      "abbr": "RADM"
    },
    "vice_admiral": {
      "name": "Vice Admiral",
      "abbr": "VADM"
    },
    "admiral": {
      "name": "Admiral",
      "abbr": "ADM"
    },
    "admiral_of_the_fleet": {
      "name": "Admiral of the Fleet",
      "abbr": "AF"
    }
  },
  "liveries": {
    "standard_grey": {
      "name": "Standard Grey",
      "blurb": "Yard paint. Nothing more."
    },
    "admiralty_blue": {
      "name": "Admiralty Blue",
      "blurb": "Dark blue topsides and a brass waterline."
    },
    "north_sea": {
      "name": "North Sea",
      "blurb": "Cold bands of grey and steel — dissolves into the swell."
    },
    "dazzle_crimson": {
      "name": "Crimson Dazzle",
      "blurb": "Broken red and black wedges. Visible at three kilometres — that is the point."
    },
    "dazzle_arctic": {
      "name": "Arctic Dazzle",
      "blurb": "White and graphite. Winter convoy."
    },
    "splinter_jade": {
      "name": "Jade Splinter",
      "blurb": "Angular facets of green and sand."
    },
    "splinter_ember": {
      "name": "Ember Splinter",
      "blurb": "Black facets with an orange spark."
    },
    "gilded_admiral": {
      "name": "Admiral's Gold",
      "blurb": "Black lacquer and a gilded stripe. A premium livery."
    },
    "veteran_slate": {
      "name": "Veteran Slate",
      "blurb": "Awarded for long service. Cannot be bought."
    },
    "season_laurel": {
      "name": "Season Laurel",
      "blurb": "A seasonal award. Cannot be bought."
    }
  },
  "ensigns": {
    "plain_navy": {
      "name": "Fleet"
    },
    "white_ensign": {
      "name": "White Ensign"
    },
    "tricolour": {
      "name": "Tricolour"
    },
    "saltire_blue": {
      "name": "Blue Saltire"
    },
    "saltire_red": {
      "name": "Burgundy Cross"
    },
    "nordic_gold": {
      "name": "Northern Cross"
    },
    "nordic_white": {
      "name": "Ice Cross"
    },
    "canton_star": {
      "name": "Canton"
    },
    "quarters_black": {
      "name": "Quarters"
    },
    "bars_sand": {
      "name": "Sand Bars"
    },
    "bars_sea": {
      "name": "Sea Bars"
    },
    "vbars_ember": {
      "name": "Ember Pennant"
    },
    "gilded_ensign": {
      "name": "Gilded Standard"
    },
    "laurel_ensign": {
      "name": "Laurel Pennant"
    }
  },
  "quests": {
    "daily_sorties": {
      "name": "Sail three battles",
      "description": "Fight three battles, however they end."
    },
    "daily_damage": {
      "name": "Deal 40,000 damage",
      "description": "Total damage dealt to enemy ships today."
    },
    "daily_kills": {
      "name": "Sink three ships",
      "description": "Finish off three enemy ships."
    },
    "daily_wins": {
      "name": "Win twice",
      "description": "Two victories today."
    },
    "weekly_wins": {
      "name": "Ten victories",
      "description": "Ten wins this week."
    },
    "weekly_damage": {
      "name": "Deal 300,000 damage",
      "description": "Total damage dealt this week."
    },
    "weekly_kills": {
      "name": "Sink forty ships",
      "description": "Forty ships sunk this week."
    }
  },
  "season": {
    "firstCampaign": "First Campaign",
    "tier": {
      "bronze": "Bronze",
      "silver": "Silver",
      "gold": "Gold",
      "admiralty": "Admiralty"
    }
  },
  "pass": {
    "season": { "season_1": "Season 1: First Watch" },
    "tier": "Tier {tier}",
    "xpAt": "{xp} XP",
    "track": { "free": "Free", "premium": "Premium" },
    "locked": "Locked",
    "needsPremium": "Premium",
    "currentTier": "Tier {tier} · {xp} pass XP",
    "nextTier": "{have} / {need} to tier {tier}",
    "complete": "Every tier open",
    "ready": { "one": "{count} reward ready", "other": "{count} rewards ready" },
    "xpHint": "Pass XP comes from finishing battles and from claiming orders and campaigns.",
    "premiumOwned": "Premium unlocked",
    "unlock": "Unlock premium {price}",
    "buyAria": "Unlock the premium track for {price} seals",
    "claimed": "Tier {tier} reward collected.",
    "unlocked": "Premium track unlocked.",
    "unavailable": "The pass is unavailable.",
    "none": "No season pass is running.",
    "confirm": {
      "title": "Unlock the premium track of {name}?",
      "body": "Every premium reward of the season, tier by tier as you earn the XP. The premium account in the Boosters tab is separate.",
      "yes": "Unlock"
    },
    "error": {
      "claim": "The reward could not be claimed.",
      "unlock": "The premium track could not be unlocked."
    }
  },
  "tasks": {
    "monthly_sorties": { "name": "A month at sea", "description": "Fight {target} battles this month." },
    "monthly_victories": { "name": "A month of victories", "description": "Win {target} battles this month." },
    "monthly_sinkings": { "name": "Wolfpack", "description": "Sink {target} ships this month." },
    "monthly_damage": { "name": "Heavy metal", "description": "Deal {target} damage this month." },
    "monthly_orders": { "name": "Dutiful captain", "description": "Claim {target} orders this month." },
    "monthly_refits": { "name": "Refit season", "description": "Buy {target} items at the shipyard this month." },
    "super_sorties": { "name": "Old salt", "description": "Fight {target} battles." },
    "super_victories": { "name": "The admiral's record", "description": "Win {target} battles." },
    "super_sinkings": { "name": "Scourge of the seas", "description": "Sink {target} ships." },
    "super_damage": { "name": "Iron rain", "description": "Deal {target} damage." },
    "super_orders": { "name": "Always on orders", "description": "Claim {target} orders." },
    "super_refits": { "name": "Master of the yard", "description": "Buy {target} items at the shipyard." },
    "global_victories": { "name": "Fleet victories", "description": "Together, win {target} battles this week." },
    "global_sinkings": { "name": "Fleet hunt", "description": "Together, sink {target} ships this week." },
    "global_sorties": { "name": "The fleet at sea", "description": "Together, fight {target} battles this month." },
    "global_damage": { "name": "Fleet bombardment", "description": "Together, deal {target} damage this month." }
  },
  "boards": {
    "title": "Leaderboards",
    "openBlurb": "Season rating, your country, damage and ships sunk, across the whole fleet.",
    "tab": { "season_rating": "Season", "country_rating": "Country", "lifetime_damage": "Damage", "lifetime_kills": "Sunk" },
    "unit": { "season_rating": "rating", "country_rating": "rating", "lifetime_damage": "damage", "lifetime_kills": "ships" },
    "countryUnknown": "We do not know your country yet. It is taken from where you connect from, or from your billing address.",
    "you": "You",
    "positionOf": "of {total}",
    "wins": { "one": "{n} win", "other": "{n} wins" },
    "winRate": "{percent}% won",
    "live": "Live",
    "refresh": "Refresh the board",
    "loading": "Reading the boards…",
    "unavailable": "The boards are unavailable.",
    "retry": "Try again"
  },
  "leaderboard": {
    "season_rating": "Season rating",
    "country_rating": "Country rating",
    "lifetime_damage": "Damage of all time",
    "lifetime_kills": "Ships sunk"
  },
  "inbox": {
    "title": "Inbox",
    "loading": "Opening the mail bag…",
    "unread": "Unread",
    "newCount": "{count} new",
    "tab": {
      "all": "All",
      "orders": "Orders",
      "ranks": "Rank",
      "chandler": "Chandler"
    },
    "empty": {
      "all": "Nothing in the mail yet.",
      "orders": "No orders have paid out yet.",
      "ranks": "No promotions yet. Win battles to climb.",
      "chandler": "Nothing from the chandler yet."
    },
    "open": {
      "orders": "Open orders",
      "record": "Open record",
      "boards": "Leaderboards",
      "chandler": "Open chandler",
      "market": "Open sales"
    }
  },
  "notify": {
    "reward_collected": { "title": "Reward collected", "body": "{order}: {reward}." },
    "quest_ready": { "title": "Order complete", "body": "{order} is done. Collect your reward." },
    "task_ready": { "title": "Campaign complete", "body": "{order} is done. Collect your reward." },
    "rank_up": { "title": "Promoted", "body": "You are now {rank}." },
    "season_tier": { "title": "New season tier", "body": "Your rating reached {tier}." },
    "deposit_credited": { "title": "Seals credited", "body": "{sealCount} seals are in your purse." },
    "booster_expired": { "title": "Booster used up", "body": "{booster} has no battles left. Buy another to keep the bonus." },
    "premium_expired": { "title": "Premium account ended", "body": "Your premium account has run out. Renew it at the chandler." },
    "sale_settled": { "title": "Sale paid out", "body": "Your sale has settled and the payout is in your stores." },
    "system": { "title": "News from the admiralty", "body": "There is news from headquarters." }
  },
  "tree": {
    "title": "Research tree",
    "howto": {
      "show": "How it works",
      "hide": "Hide help",
      "step1": "Sail a hull",
      "step2": "Research its bush",
      "step3": "Buy the next ship"
    },
    "ribbon": {
      "active": "In service",
      "owned": "In fleet",
      "buyable": "Researched",
      "available": "Research",
      "locked": "Locked"
    },
    "tab": {
      "ship": "Ship",
      "research": "Research"
    },
    "line": {
      "destroyer": "Destroyers",
      "cruiser": "Cruisers",
      "battleship": "Battleships"
    },
    "stat": {
      "hp": "Hit points",
      "speed": "Top speed",
      "turn": "Turn rate",
      "concealment": "Seen from",
      "guns": "Main guns",
      "torpedoes": "Torpedo tubes"
    },
    "unit": {
      "speed": "{value} m/s",
      "turn": "{value}°/s",
      "metres": "{value} m",
      "guns": "{count} × {damage}"
    },
    "cost": {
      "research": "Research",
      "ship": "Ship",
      "free": "Free"
    },
    "action": {
      "buy": "Buy",
      "command": "Take command",
      "fit": "Fit out in shipyard",
      "gotoGate": "See {name}'s bush"
    },
    "hint": {
      "available": "Ready to research on {name}'s own bush.",
      "locked": "Research {items} first."
    },
    "done": {
      "bought": "{name} joins your fleet."
    },
    "zoom": {
      "label": "Zoom",
      "in": "Zoom in",
      "out": "Zoom out",
      "fit": "Whole tree"
    }
  },
  "research": {
    "kind": {
      "gun": "Guns B",
      "hull": "Hull B",
      "propulsion": "Propulsion",
      "fire_control": "Fire Control",
      "torpedoes": "Torpedoes B",
      "next_hull": "Next Hull",
      "line_opener": "Open the Line"
    },
    "xpUnit": "XP",
    "state": {
      "researched": "Researched",
      "available": "Ready to research",
      "locked": "Locked"
    },
    "stat": {
      "hpMult": "Hull",
      "turnMult": "Turn rate",
      "concealmentMult": "Seen from",
      "statusDurationMult": "Fire and flooding last",
      "accelMult": "Acceleration",
      "speedMult": "Top speed",
      "dispersionMult": "Dispersion",
      "shellSpeedMult": "Shell speed",
      "reloadMult": "Reload",
      "torpedoDamageMult": "Torpedo damage",
      "torpedoReloadMult": "Torpedo reload",
      "tubes": "Torpedo tubes"
    },
    "effect": {
      "unlocks": "Unlocks {name} for purchase"
    },
    "hullXp": "Hull XP",
    "elite": "Elite",
    "pool": "Common pool: {xp} XP",
    "buy": "Research",
    "buyConfirm": "Research {name}",
    "done": {
      "bought": "{name} researched."
    },
    "bush": {
      "title": "This hull's research"
    },
    "convert": {
      "title": "Convert",
      "action": "Convert",
      "pool": "Common pool",
      "amount": "XP to move",
      "empty": "No spare XP to convert.",
      "confirm": "Move {xp} XP to {name}",
      "done": "{xp} XP moved to {name}."
    },
    "sale": {
      "price": "Shipyard price",
      "bought": "Bought"
    }
  },
  "shop": {
    "title": "Ship's Chandler",
    "balance": "You have",
    "purchased": {
      "title": "Seals aboard",
      "lede": "Your payment went through and the seals are in your purse.",
      "balance": "You now have",
      "back": "Back to the Chandler"
    },
    "shortfall": {
      "title": "Not enough seals",
      "lede": "You are short by",
      "ladder": "Buy seals"
    },
    "rewarded": {
      "title": "Watch an ad",
      "reward": "+{silver} credits",
      "left": "{count} left today",
      "watch": "Watch",
      "noAd": "No ad was completed, so nothing was paid.",
      "done": "{silver} credits added to your purse.",
      "failed": "The ad reward did not go through.",
      "cap": "No more ads today. Come back tomorrow.",
      "interval": "The next ad is ready at {time}."
    },
    "exchange": {
      "limit": "That is more than today's limit allows. Try fewer seals.",
      "go": "Exchange",
      "confirmTitle": "Exchange seals for credits?",
      "confirmBody": "You get {silver} credits after the {fee}-credit fee. This cannot be undone.",
      "confirmYes": "Exchange",
      "done": "{silver} credits added to your purse.",
      "failed": "The exchange did not go through.",
      "lead": "Seals go in, credits come out — the Chandler keeps {fee}% off the top. {left} credits left today.",
      "bundle": { "purse": "A purse of credits", "crate": "A crate of credits", "chest": "The strongbox" },
      "credited": "Credited",
      "grossShort": "Gross {gross}",
      "customTitle": "Name your own amount",
      "customNote": "Any amount from 1 to {max} seals, at the same rate as the hauls above.",
      "amount": "Seals to exchange",
      "gross": "Gross",
      "cut": "Chandler's cut {fee}%",
      "short": "Short {count} seals for this exchange — the Chandler sells them.",
      "getSeals": "Buy seals"
    },
    "tabs": {
      "exchange": "Exchange",
      "buy": "Buy seals",
      "boosters": "Boosters",
      "pass": "Pass",
      "purchases": "Purchases",
      "withdraw": "Withdraw"
    },
    "withdraw": {
      "unavailable": "Withdrawals are not available right now.",
      "sealsLabel": "Seals to withdraw",
      "fee": "Fee",
      "receive": "You receive",
      "tooFew": "Minimum {min} seals.",
      "tooMany": "Maximum {max} seals.",
      "feeTooHigh": "Amount does not cover the withdrawal fee.",
      "pending": "You already have a withdrawal in progress.",
      "billingRequired": "Complete your billing address before withdrawing.",
      "capInfo": "Withdrawals capped at {amount} (total deposits).",
      "capTooLow": "Remaining withdrawal cap is below the minimum payout amount."
    },
    "opening": "Opening the shutters…",
    "loadFailed": "The chandler is shut — stores could not be loaded.",
    "checkoutFailed": "Payment did not start.",
    "credited": "+{count} seals credited.",
    "creditedPlain": "Seals credited.",
    "confirming": "Confirming your payment…",
    "declined": "Payment did not go through. Nothing was charged.",
    "review": "Your payment is under review. The seals will follow once it is confirmed; check Purchases.",
    "returnedUnknown": "Your payment is being processed. The seals will appear as soon as it clears; check Purchases.",
    "bonus": "+{count} bonus",
    "custom": {
      "title": "Any amount",
      "label": "Amount in euros",
      "range": "{min} – {max}",
      "refused": "Enter an amount from {min} to {max}.",
      "rangeLocal": "About {min} – {max} at today's rate",
      "noBonus": "Packs give more seals for the money; any amount has no bonus.",
      "buy": "Pay {price}",
      "buyIdle": "Enter an amount",
      "math": {
        "aria": "How the amount is worked out",
        "amount": "Amount",
        "rate": "Rate",
        "rateValue": "{price} per 100 seals",
        "fee": "Payment fee {pct}%",
        "feeNote": "included",
        "charged": "Charged",
        "credited": "Seals credited"
      }
    },
    "pay": {
      "title": "Pay with",
      "off": "Payments are not available yet. Please check back soon.",
      "billingWhere": "Open the Captain's papers and fill in the Billing tab.",
      "errors": {
        "unavailable": "That way of paying is not available right now.",
        "amount": "That amount cannot be bought. Check the range and try again.",
        "product": "That pack is no longer on sale.",
        "billing": "This way of paying needs a complete billing address. Add it in the Captain's papers.",
        "currency": "That currency is not available right now. Pick another way of paying.",
        "email": "Confirm your email address before buying.",
        "kyc": "Your identity must be verified before buying.",
        "pending": "You have payments still open. Wait for them to finish, then try again."
      }
    },
    "stamp": {
      "best": "Best value"
    },
    "purchases": {
      "invoice": "Invoice"
    }
  },
  "boosters": {
    "section": {
      "premium": "Premium account",
      "credits": "Credit boosters",
      "xp": "XP boosters"
    },
    "tier": {
      "bronze": "Bronze",
      "silver": "Silver",
      "gold": "Gold"
    },
    "sku": {
      "credit_bronze": "Bronze credit booster",
      "credit_silver": "Silver credit booster",
      "credit_gold": "Gold credit booster",
      "xp_bronze": "Bronze XP booster",
      "xp_silver": "Silver XP booster",
      "xp_gold": "Gold XP booster"
    },
    "battles": { "one": "{count} battle", "other": "{count} battles" },
    "daysUnit": { "one": "day", "other": "days" },
    "from": "from {price}",
    "buyAria": "Buy {name} for {price} seals",
    "ownedLeft": { "one": "{count} battle left", "other": "{count} battles left" },
    "negative": "Your seal balance is negative after a refund. Top up to clear it before spending.",
    "bought": "{name} bought.",
    "spend": "Deposits in the last {days} days: {amount}",
    "premium": {
      "pack": { "one": "Premium account, {count} day", "other": "Premium account, {count} days" },
      "bonus": "+{percent}% credits and XP",
      "active": "Premium is active until {date}."
    },
    "confirm": {
      "title": "Buy {name}?",
      "yes": "Buy",
      "large": "This is a large spend.",
      "soft": "You have deposited a lot recently. Make sure this is what you want."
    },
    "error": {
      "confirmRequired": "That spend needs your confirmation. Try again.",
      "balanceNegative": "Your seal balance is negative after a refund. Top up to clear it before spending.",
      "freeXpCap": "Today's Free XP limit is reached. It resets at midnight UTC.",
      "failed": "The purchase did not go through."
    },
    "unit": {
      "day": "{count}d",
      "hour": "{count}h"
    },
    "chip": {
      "premium": "Premium, {time} left",
      "credits": "Next battle: {mult} credits",
      "xp": "{mult} XP",
      "left": { "one": "{count} battle of boost left", "other": "{count} battles of boost left" }
    }
  },
  "freeXp": {
    "title": "Buy XP",
    "tabs": "XP exchange",
    "note": "Seals into common-pool XP. Spend it on any hull with Convert.",
    "rate": "{rate} XP per seal",
    "amount": "Seals to spend",
    "picks": "Quick amounts",
    "max": "Max",
    "left": "{left} of {cap} XP left today",
    "capReached": "Today's limit is reached. It resets at midnight UTC.",
    "noSeals": "Not enough seals.",
    "unavailable": "Free XP could not be read.",
    "action": "Buy",
    "confirm": "Buy {xp} XP",
    "confirmBody": "The XP goes to the common pool.",
    "done": "{xp} XP added to the common pool.",
    "failed": "The XP was not bought."
  },
  "offers": {
    "unit": {
      "day": "d",
      "hour": "h"
    },
    "stamp": {
      "best": "Best value",
      "deal": "Deal"
    },
    "kicker": {
      "login": "Chandler's notice",
      "lowCredits": "Short of credits?",
      "afterBattle": "Fresh from the sortie"
    },
    "ends": "Ends in {time}",
    "open": "Open the Chandler",
    "openDeal": "{name}: {price}. Open the Chandler",
    "close": "Close this offer",
    "saving": "Save {percent}%",
    "chalkboard": {
      "aria": "Chandler's deal board"
    },
    "alt": {
      "pack": "{name} pack"
    }
  },
  "admin": {
    "offers": {
      "title": "Offers",
      "lede": "Where the harbour shows a deal outside the Chandler, and how often. The server decides; these are its limits.",
      "capsTitle": "Daily caps per player",
      "capHint": "per UTC day, -1 unlimited, 0 never",
      "chandlerHint": "always shown, fixed",
      "thresholdTitle": "Low credits",
      "lowCreditsBelow": "Show the low-credits offer below this many credits",
      "placement": {
        "login": "Harbour notice at sign-in",
        "after_battle": "After a battle",
        "low_credits": "Purse running low",
        "chandler": "Chandler's board"
      },
      "save": "Save offers",
      "saved": "Offers saved."
    },
    "ads": {
      "title": "Rewarded ads",
      "lede": "Watching an ad pays {silver} credits. The server verifies each view with the ad network and enforces these limits.",
      "providerOff": "No ad network is connected (env {env} is none), so no ad is offered whatever is set below.",
      "providerOn": "Ad adapter: {name}.",
      "enabled": "Rewarded ads switched on",
      "maxPerDay": "Views per player per UTC day",
      "minIntervalMin": "Minutes between two views",
      "save": "Save ad limits",
      "saved": "Ad limits saved."
    },
    "market": {
      "title": "Market",
      "lede": "What the yard pays when a player sells back something bought with seals. The server enforces these; selling can never beat buying.",
      "valuePct": "Buy-back value, % of the lowest seal price",
      "instantPayoutPct": "Instant sale pays, % of the value",
      "delayedPayoutPct": "Delayed sale pays, % of the value",
      "delayHours": "Delayed sale waits, hours",
      "range": "{min} to {max}",
      "defaultHint": "default {value}",
      "example": "A 1,000-seal item pays {instant} seals now, or {delayed} after {hours} hours.",
      "instantAboveDelayed": "An instant sale may not pay more than a delayed one.",
      "edit": "Edit numbers",
      "save": "Save market",
      "saved": "Market saved."
    }
  }
}
